var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.403 12.3h2.444v6H6.403zm4.277.6h2.444v5.4H10.68zm4.276-3H17.4v8.4h-2.444zm0-4.8H17.4v2.4h-.61V6.336l-4.907 4.818-2.425-2.382-2.81 2.76L6 10.896 9.458 7.5l2.425 2.382L16.142 5.7h-1.186z"
})));
export default SvgFinance;